'use strict'

import React from 'react';
import uuid from 'uuid';

import Layout from './Layout.jsx';
import Area from './components/Area2.jsx';
import Field from './components/Field3.jsx';
import ProjectMenu from './components/ProjectMenu.jsx';

import request from 'superagent';
import Translations from '../app/utils/translations.js';

let translations=new Translations([
    require('./organization/labels/english.js'),
    require('./organization/labels/norwegian.js')
]);

class Person extends React.Component {
  constructor(props) {
    super(props);
    this.state={role:props.role, selectRole:false, editDetails:false, details:props.details};
  }

  assignRole(event) {
    event.preventDefault();
    this.setState({selectRole:true});
  }

  editDetails(event) {
    event.preventDefault();
    this.setState({editDetails:true});
  }

  cancelRoleUpdate() {
    this.setState({selectRole:false});
  }

  cancelDetailsUpdate() {
    this.setState({editDetails:false});
  }

  updatedRole(event) {
    event.preventDefault();
    var value=event.target.value;
    var updateUI=function() {
      this.setState({selectRole:false, role:value, details:undefined});
    }.bind(this);
    if (this.props.onCommand!==undefined) {
      this.props.onCommand(
        {
          type:"assignRole", person:{id:this.props.id}, role:{text:value}
        },
        updateUI
      );
    }
  }

  updatedDetails(event) {
    event.preventDefault();
    var value=event.target.details.value;
    var updateUI=function() {
      this.setState({editDetails:false, details:value});
    }.bind(this);
    if (this.props.onCommand!==undefined) {
      this.props.onCommand(
        {
          type:"setRoleDetails", person:{id:this.props.id}, role: { text: this.state.role }, details:value
        },
        updateUI
      );
    }
  }

  deleteRole(event) {
    event.preventDefault();
    this.setState({confirmDelete:true});
    console.log("Please confirm that you want to remove "+this.props.name+" with role "+this.state.role+" - "+this.state.details);
  }

  confirmedDelete(event) {
    event.preventDefault();
    var updateUI=function() {
      this.setState({confirmDelete:false});
    }.bind(this);
    if (this.props.onCommand!==undefined) {
      this.props.onCommand(
        {
          type:"deleteRole", person:{id:this.props.id}, role: { text: this.state.role }, details:this.state.details
        },
        updateUI
      );
    }
  }

  cancelDelete(event) {
    event.preventDefault();
    this.setState({confirmDelete:false});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    let roles=
          this.props.type==="product"
          ? [ {id:"Excecutive", name:labels.roles.product.executive},
              {id:"Product Manager", name:labels.roles.product.productManager},
              {id:"Team Manager", name:labels.roles.product.teamManager},
              {id:"Stakeholder", name:labels.roles.product.stakeholder},
              {id:"Team Member", name:labels.roles.product.teamMember}]

          : this.props.type==="programme"
          ? [ {id:"Senior Responsible Owner", name:labels.roles.programme.seniorResponsibleOwner},
              {id:"Programme Manager", name:labels.roles.programme.programmeManager},
              {id:"Business Change Manager", name:labels.roles.programme.businessChangeManager},
              {id:"Stakeholder", name:labels.roles.programme.stakeholder},
              {id:"Team Member", name:labels.roles.programme.teamMember}]

          : [ {id:"Excecutive", name:labels.roles.project.executive},
              {id:"Senior User", name:labels.roles.project.seniorUser},
              {id:"Senior Supplier", name:labels.roles.project.seniorSupplier},
              {id:"Business Assurance", name:labels.roles.project.businessAssurance},
              {id:"Project Manager", name:labels.roles.project.projectManager},
              {id:"Team Manager", name:labels.roles.project.teamManager},
              {id:"Project Support", name:labels.roles.project.projectSupport},
              {id:"Change Authority",name:labels.roles.project.changeAuthority},
              {id:"Stakeholder", name:labels.roles.project.stakeholder},
              {id:"User Assurance", name:labels.roles.project.userAssurance},
              {id:"Supplier Assurance", name:labels.roles.project.supplierAssurance},
              {id:"Team Member", name:labels.roles.project.teamMember}];

    return (

      <tr>
        <td style={{paddingBottom:10}}>
          {this.state.confirmDelete ? (
            <div style={{position: "relative"}}>
              <div style={{position:"absolute", border: "solid 1px black", backgroundColor:"white", padding:20, minWidth:300}}>
                <div style={{paddingBottom:10}}>
                  Do you want to remove <b>{this.props.name}</b> with role <b>{this.state.role} {this.props.details!==undefined ? " - "+this.props.details : ""}</b>?
                </div>
                <input className="cancel" onClick={this.cancelDelete.bind(this)} type="button" value={labels.general.cancel}/>
                <input className="save" onClick={this.confirmedDelete.bind(this)} type="button" value="Remove role"/>
              </div>
            </div>
          ) : this.state.role!==undefined ? (
            <a href="#" onClick={this.deleteRole.bind(this)} style={{marginLeft: 0, position: "relative", marginRight: 15}}>
              <span style={{color: "red", position: "absolute", left: -3, top: -1, fontWeight: "bold", fontFamily:"Arial"}}>x</span>
            </a>
            ) : null}

        </td>
        <td style={{paddingRight: 20, paddingBottom: 10}}>{this.props.name}</td>
        <td style={{paddingRight: 20, paddingBottom: 10}}>{this.props.email}</td>
        <td style={{paddingBottom:10}}>
          {this.state.selectRole ? (
            <div>
              <div style={{display:"inline-block"}}>
                <select className="input"
                        defaultValue={this.state.role}
                        onChange={this.updatedRole.bind(this)}
                        style={{fontFamily: "lato, Arial, Verdana, Geneva, sans-serif", fontSize:"12pt"}}>
                  {(this.state.role===undefined ? [{id:"Dummy",name: labels.roles[this.props.type].selectRole}] : []).concat(roles).map(role=><option key={role.id} value={role.id}>{role.name}</option>)}
                </select>
              </div>
              <div style={{display:"inline-block", verticalAlign:"middle"}}>
                <input className="cancel" style={{marginLeft: 10}} onClick={this.cancelRoleUpdate.bind(this)} type="button" value={labels.general.cancel}/>
              </div>
            </div>
          ) : this.state.role!==undefined ? (
            <div style={{display:'flex'}}>
              <div>
                {roles.find(role=>role.id===this.state.role)!==undefined ? roles.find(role=>role.id===this.state.role).name : null}
                {this.props.additionalRoles!==undefined && this.props.additionalRoles.length>0 ? (
                  <div>
                    {this.props.additionalRoles.map(item=>(
                      <div style={{paddingTop:3, color:'grey'}}>{roles.find(role=>role.id===item.role // camelCase to Title Case
                        .replace(/([A-Z])/g, (match) => ` ${match}`)
                        .replace(/^./, (match) => match.toUpperCase())
                        .trim()).name}  <span style={{color:'red'}}>*</span></div>)
                    )}
                  </div>
                ) : null}
              </div>
              <span style={{paddingLeft: 5}}/>
              {!this.state.editDetails ? (
                <a href="#" onClick={this.assignRole.bind(this)}><img style={{verticalAlign:"middle"}} src="/icons/pen_grey.jpg"/></a>
                ) : null}
            </div>
            ) : (
              <a href="#" onClick={this.assignRole.bind(this)}>{labels.general.assignRole}</a>
          )}
        </td>
        <td style={{paddingBottom:10}}>
          {this.state.editDetails ? (
            <div>
              <form onSubmit={this.updatedDetails.bind(this)}>
                <div style={{paddingBottom: 10, display: "inline-block"}}>
                  <input name="details" className="input" defaultValue={this.state.details} style={{fontFamily: "Lato,Arial, Verdana, Geneva, sans-serif", fontSize:"12pt"}}/>
                </div>
                <div style={{display:"inline-block", verticalAlign:"middle"}}>
                  <input className="cancel" style={{marginLeft: 10}} onClick={this.cancelDetailsUpdate.bind(this)} type="button" value={labels.general.cancel}/>
                  <input className="save" style={{marginLeft: 10}} type="submit" value={labels.general.update}/>
                </div>
              </form>
            </div>
          ) : this.state.role!==undefined && !this.state.selectRole ? (
             this.state.details ? (
              <div style={{display:'flex'}}>
                <div>
                  {this.state.details}
                  {this.props.additionalRoles!==undefined && this.props.additionalRoles.length>0 ? (
                    <div>
                      {this.props.additionalRoles.map(item=>(
                        <div style={{paddingTop:3,color:'grey'}}>{item.details} <span style={{color:'red'}}>*</span></div>)
                      )}
                    </div>
                  ) : null}
                </div>
                <a href="#" onClick={this.editDetails.bind(this)}><img style={{verticalAlign:"middle"}} src="/icons/pen_grey.jpg"/></a>
              </div>
            ) : (
              <div>
                <a href="#" onClick={this.editDetails.bind(this)}>{labels.general.addRoleDetails}</a>
                {this.props.additionalRoles!==undefined && this.props.additionalRoles.length>0 ? (
                  <div>
                    {this.props.additionalRoles.map(item=>(
                      <div style={{paddingTop:3,color:'grey'}}>{item.details} <span style={{color:'red'}}>*</span></div>)
                    )}
                  </div>
                ) : null}
              </div>
            )
          ) :
          (
            <div/>
          )
        }
        </td>
      </tr>

    );
  }
}

class AddPersonForm extends React.Component {
  constructor(props) {
    super(props);
    this.state={email:"",name:"",lockName:true};
  }

  updateEmail(event) {
    var newValue=event.target.value.trim();
    var newState={id:undefined};
    if (newValue.slice(-1)===";") {
      newValue=newValue.slice(0,-1);
    }
    if (newValue[newValue.length-1]===">" && event.target.value.indexOf("<")>0) {
      newState.name=newValue.substring(0,newValue.indexOf("<")-1);
      newState.email=newValue.substring(newValue.indexOf("<")+1,newValue.length-1);
      newState.lockName=undefined;
    } else {
      var validEmail=newValue.indexOf("@")>0 && newValue.lastIndexOf(".")>newValue.indexOf("@");
      newState.email=newValue;
      newState.lockName=!validEmail ? true : undefined;
    }
    if (this.props.lookupPerson!==undefined) {
      this.props.lookupPerson(newState.email,function(person) {
        newState.name=person.name;
        newState.id=person.id;
        newState.lockName=true;
        this.setState(newState);
      }.bind(this));
    }
    this.setState(newState);
  }

  updateName(event) {
    this.setState({name:event.target.value});
  }

  addPerson(event) {
    this.props.onCommand({type:"addPerson",person:{id: this.state.id===undefined ? uuid.v4() : this.state.id, name:this.state.name,email:this.state.email}});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <form>
        <Area title={labels.general.newStakeholder}>
          <Field
            title={labels.roles.headings.email}
            controlled={true}
            onChange={this.updateEmail.bind(this)} value={this.state.email}
          />
          <Field
            title={labels.roles.headings.name}
            onChange={this.updateName.bind(this)} help={this.state.lockName ? labels.general.messageEmailFirst : labels.general.helpName} value={this.state.name}
            controlled={true}
            disabled={this.state.lockName}
          />
        </Area>
        <input className="cancel" onClick={this.props.cancel} type="button" value={labels.general.cancel}/>
        <input className="save" onClick={this.addPerson.bind(this)} type="button" value={labels.general.addStakeholder}/>
      </form>
    );
  }
}

class Description extends React.Component {
  constructor(props) {
    super(props);
    this.state={showDetails:false};
  }

  toggleDisplay(event) {
    event.preventDefault();
    this.setState({showDetails: !this.state.showDetails});
  }

  render() {
    let labels=translations.getTranslation(this.props).general;
    return (
      <div style={{paddingBottom:10}}>
        <div>
          <strong>{this.props.title}</strong>
            {this.state.showDetails ? <span> [<a onClick={this.toggleDisplay.bind(this)} href="#">{labels.hideDetails}</a>]</span> : null}
        </div>
        {this.state.showDetails ? (
          <div style={{border:"solid 1px lightgrey", borderRadius:5, padding:10}}>
            {this.props.children}
          </div>
        ) : (
          <div>
            {this.props.ingress}
            <span> [<a onClick={this.toggleDisplay.bind(this)} href="#">{labels.readMore}</a>]</span>
          </div>
        )}
      </div>
    );
  }
}

class RoleDescriptions extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).roles;
    return (
      <div style={{marginLeft:30, marginTop:55, maxWidth:630, minWidth:300}}>
        <h3>{labels.title}</h3>
        <Description {...this.props} {...labels.project.descriptions.board}>
          <div>
            <div>
              {labels.project.descriptions.board.details}
            </div>
            <ul>
              {["executive","seniorUser","seniorSupplier"].map(role=>(
                <li key={role}>{labels.project.roles[role].title} - {labels.project.roles[role].summary}</li>
              ))}
            </ul>
            <div style={{paddingBottom:10}}>
              {labels.project.descriptions.board.responsibility}
            </div>
            {["executive","seniorUser","seniorSupplier"].map(role=>(
              <Description key={role} {...this.props} {...labels.project.roles[role]}>
                <div>
                  {labels.project.roles[role].details}
                </div>
              </Description>
            ))}
          </div>
        </Description>
        <Description {...this.props} {...labels.project.roles.projectManager}>
          {labels.project.roles.projectManager.details}
        </Description>
        <Description {...this.props} {...labels.project.roles.teamManager}>
          {labels.project.roles.teamManager.details}
        </Description>
        <Description {...this.props} {...labels.project.descriptions.assuranceRoles}>
           {labels.project.descriptions.assuranceRoles.details}
        </Description>
      </div>
    );
  }
}

export class Organization extends React.Component {
  constructor(props) {
    super(props);

    var stakeholders=this.props.project!==undefined && this.props.project.stakeholders!==undefined ? this.props.project.stakeholders : [];
    var user=this.props.user;
    if (stakeholders.filter(person=>person.id===user.id).length===0 && user!==undefined) {
      stakeholders=stakeholders.concat(user);
    }
    this.state={showForm:false, persons:stakeholders};
  }

  showForm(event) {
    event.preventDefault();
    this.setState({showForm:true});
  }

  sendCommand(command,success) {
    request
      .post("/")
      .send(command)
      .end(function(error, response) {
        if (error===null && response.status===200 && response.text==="OK") {
          console.log("Success for command '"+command.type+"'");
          success();
        } else {
          console.log("Error: "+error+", got "+response.status+" with message "+response.text);
          alert("An error occoured, please try again.");
        }
      });
  }

  onCommand(command,success) {
    switch (command.type) {
      case "addPerson":
        if (this.state.persons.filter(person=>person.id===command.person.id).length>0) {
          alert("Person can only have one role in the "+(this.props.project.isProduct===true ? "product" : this.props.project.isProgramme===true ? "programme" : "project"));
        } else {
          this.addPerson(command.person);
        }
        break;
      case "assignRole":
      case "setRoleDetails":
      case "deleteRole":
        var enrichedCommand=Object.assign({},command,{tenant:{id:this.props.tenant.id}});
        if (this.props.project.isProduct===true) {
          enrichedCommand.product={id:this.props.project.id};
        } else {
          if (this.props.project.isProgramme===true) {
            enrichedCommand.programme={id:this.props.project.id};
          } else {
            enrichedCommand.project={id:this.props.project.id};
          }
        }
        this.sendCommand(enrichedCommand,function() {
          if (command.type==="deleteRole") {
            this.setState({persons:this.state.persons.filter(person=>person.id!==command.person.id)});
          } else {
            this.setState({persons:this.state.persons.map(person=>person.id===command.person.id ? Object.assign({},person,{role:command.role.text,details:command.details}): person)});
          }
          success();
        }.bind(this));
        break;
      default:
        alert("Not supported");
    }
  }

  addPerson(person) {
    var tenant=this.props.tenant;
    var updateUI=function() {
       this.setState({
              showForm:false,
              persons:this.state.persons.concat(person)
            });
    }.bind(this);

    var project=this.props.project;
    var command={type:"addPerson",person:person,tenant:{id:tenant.id}};
    if (this.props.project.isProduct===true) {
      command.product={id:project.id};
    } else {
      if (this.props.project.isProgramme===true) {
        command.programme={id:project.id};
        console.log("Added programme person "+person.name)
      } else {
        command.project={id:project.id};
      }
    }
    console.log("Added  "+person.name)
    this.sendCommand(command,updateUI);
  }

  lookupPerson(email,found) {
    request
      .get("/emails/"+email)
      .send({email:email})
      .end(function(err,response) {
        if (err===null) {
          var persons=JSON.parse(response.text);
          if (persons.length>0) {
            found(persons[0]);
          }
        }
      });
  }

  hideForm(){
    this.setState({showForm:false});
  }

  goToHome() {
      {window.location.replace((this.props.project.isProduct===true ? "/products/" : this.props.project.isProgramme===true ? "/programmes/" : "/projects/")+this.props.project.id);}
  }


  render() {
    let labels=translations.getTranslation(this.props);
    var commandHandler=this.onCommand.bind(this);
    return (
      <div style={{marginLeft:30, display:"flex", flexWrap:"wrap", justifyContent:"flex-start", fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif",  maxWidth:1016}}>
        <OrganizationThemePresentation {...this.props} persons={this.state.persons}/>
        <div>
          <div style={{marginLeft: 20, fontSize:"12pt", width:"100%"}}>

        <table>
          <thead>
            <tr>
              <th></th>
              <th>{labels.roles.headings.name}</th>
              <th>{labels.roles.headings.email}</th>
              <th>{labels.roles.headings.role}</th>
              <th>{labels.roles.headings.details}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.persons.map(person=><Person {...this.props} key={person.id} {...person} type={this.props.project.isProduct===true ? "product" : this.props.project.isProgramme===true ? "programme" : "project"} onCommand={commandHandler}/>)}
          </tbody>
        </table>
        <div style={{paddingTop: 30, paddingBottom:15, maxWidth:1016, fontSize:"12pt"}}>
          {this.state.showForm ? (
            <AddPersonForm {...this.props} lookupPerson={this.lookupPerson.bind(this)} onCommand={commandHandler} cancel={this.hideForm.bind(this)}/>
          ) : (
            <div>
              <input className="cancel" onClick={this.goToHome.bind(this)} name="cancel" value={labels.general.leavePage}/>
              <input className="save" style={{marginLeft: 10}} onClick={this.showForm.bind(this)} type="button" value={labels.general.addRole}/>
            </div>

          )}
        </div>
      </div>
    </div>
      {this.props.project.isProduct!==true && this.props.project.isProgramme!==true ? (<RoleDescriptions {...this.props}/>) : null}
    </div>
    );
  }
}

class OrganizationThemePresentation extends React.Component {

  render() {
    let labels=translations.getTranslation(this.props);
    var title=labels.roles.project.actions.appointExecutive; //"Appoint Executive";

    var initiativeC=(this.props.project.isProduct===true ? "Product" : this.props.project.isProgramme===true ? "Programme" : "Project");
    var description=labels.roles.project.roles.executive.details;
    var description2=labels.roles.project.roles.executive.additionalInformation;

    if (this.props.project.isProduct===true) {
      title=labels.roles.product.actions.appointExecutive;
      description=labels.roles.product.roles.executive.details;
      description2=labels.roles.product.roles.executive.additionalInformation;

    } else if (this.props.project.isProgramme===true) {
      title=labels.roles.programme.actions.appointSRO;
      description=labels.roles.programme.roles.seniorResponsibleOwner.details;
      description2=labels.roles.programme.roles.seniorResponsibleOwner.additionalInformation;
    }
    if (this.props.persons!==undefined && this.props.persons.filter(person=>person.role==="Excecutive" || person.role==="Senior Responsible Owner" ).length>0) {
      if (this.props.persons!==undefined && this.props.persons.filter(person=>person.role==="Project Manager" && this.props.project.isProduct!==true || person.role==="Product Manager" && this.props.project.isProduct===true || person.role==="Programme Manager" && this.props.project.isProgramme===true).length>0) {
        if (this.props.project.isProduct===true) {
          title=labels.roles.product.descriptions.teamStructure.title;
          description=labels.roles.product.descriptions.teamStructure.details;
          description2=labels.roles.product.descriptions.teamStructure.additionalInformation;
        }
        else {
          if (this.props.project.isProgramme===true) {
            title=labels.roles.programme.descriptions.teamStructure.title;
            description=labels.roles.programme.descriptions.teamStructure.details;
            description2=labels.roles.programme.descriptions.teamStructure.additionalInformation;
          } else {
            title=labels.roles.project.descriptions.teamStructure.title;
            description=labels.roles.project.descriptions.teamStructure.details;
            description2=labels.roles.project.descriptions.teamStructure.additionalInformation;
          }
        }
      } else {
        if (this.props.project.isProduct===true) {
          title=labels.roles.product.actions.appointProductManager;
          description=labels.roles.product.roles.productManager.details;
          description2=labels.roles.product.roles.productManager.additionalInformation;
        }
        else {
          if (this.props.project.isProgramme===true) {
            title=labels.roles.programme.actions.appointProgrammeManager;
            description=labels.roles.programme.roles.programmeManager.details;
            description2=labels.roles.programme.roles.programmeManager.additionalInformation;
          } else {
            title=labels.roles.project.actions.appointProjectManager;
            description=labels.roles.project.roles.projectManager.details;
            description2=labels.roles.project.roles.projectManager.additionalInformation;
          }
        }

      }
    }
    return (
      <div style={{backgroundColor:"#f7f7f7", padding:20, marginBottom:30, marginTop:20, width:"100%"}}>
        <div style={{fontWeight:"bold", fontSize:14 }}>
            {labels.general.title}<br/>
        </div>
        <div style={{fontSize:30, fontWeight:"bold"}}>
            {title}
        </div>
        <div style={{display:"flex", justifyContent:"space-between"}}>
          <div style={{minWidth:200, maxWidth:550, paddingTop:20}}>
            <p>
              {description}
            </p>
            <p>
              {description2}
            </p>
          </div>
          <div style={{paddingLeft:10, paddingBottom:20, paddingRight:30, paddingTop:1}}>
              <img src="/images/orgtheme.png"></img>
          </div>
        </div>
      </div>
    );
  }
}

export default class OrganizationPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <Organization {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/Organization.jsx